/**
 * Labstep - Table Edge Handle Component
 *
 * Handles for adding rows/columns at table edges
 */

import React, { type FC, useRef } from 'react';
import styles from './styles.module.scss';

export interface TableEdgeHandleProps {
  position: { top: number; left: number };
  size: { width: number; height: number };
  type: 'bottom' | 'right';
  onClick?: () => void;
}

export const TableEdgeHandle: FC<TableEdgeHandleProps> = ({
  position,
  size,
  type,
  onClick,
}) => {
  const handleRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={handleRef}
      className={styles.edgeHandle}
      style={{
        top: position.top,
        left: position.left,
        width: type === 'bottom' ? size.width : 15,
        height: type === 'bottom' ? 15 : size.height,
      }}
      onClick={onClick}
      title={`Click to add ${type === 'bottom' ? 'row' : 'column'}`}
    >
      {'+'}
    </div>
  );
};
